import { combineReducers } from "redux";

import feedback from "./feedback";
import resources from "./resources";
import sharing from "./sharing";

const reducers = combineReducers({ feedback, resources, sharing });

export default reducers;
